<div class="form-field radio">
	<label *ngIf="label">{{ label }}</label>
	<mat-radio-group aria-label="Seleziona opzione" [formControl]="formControl" [ariaReadOnly]="readonly">
		<mat-radio-button *ngFor="let option of options" [value]="option.value" [ngClass]="{ 'no-label': !option.label }">
			{{ option.label | toLocalizedValuePipe }}
		</mat-radio-button>
	</mat-radio-group>
</div>

